// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import * as sdk from '@canton-network/dapp-sdk';
import { useEffect, useState } from 'react';

export function useAccounts(status?: sdk.dappAPI.StatusEvent) {
  const [accounts, setAccounts] = useState<sdk.dappAPI.Wallet[]>();

  useEffect(() => {
    if (status?.isConnected) {
      sdk
        .requestAccounts()
        .then((wallets) => {
          setAccounts(wallets);
        })
        .catch((err) => {
          console.error('Error requesting wallets:', err);
        });
    }
  }, [status]);

  useEffect(() => {
    if (status?.isConnected) {
      const listener = (event: sdk.dappAPI.AccountsChangedEvent) => {
        setAccounts(event);
      };

      sdk.onAccountsChanged(listener).catch(console.error);

      return () => {
        sdk.removeOnAccountsChanged(listener).catch(console.error);
      };
    }

    return () => {};
  }, [status, setAccounts]);

  return accounts;
}
